import CommentData from '../../../types/commentData';
import { useUserProfile } from '../../../utils/hooks';
import AnonymousRoundedImage from '../../atoms/rounded-image/AnonymousRoundedImage';
import UserRoundedImage from '../../atoms/rounded-image/UserRoundedImage';

import './CommentInOverview.scss';

interface CommentCardProps {
  comment: CommentData;
  className?: string;
  answers: number;
}

export default function CommentInOverview({ comment, className = '', answers }: CommentCardProps) {
  const userProfile = useUserProfile(comment.userId);

  return (
    <div className={`comment-in-overview ${className}`}>
      {userProfile &&
        (comment.userId !== null ? (
          <UserRoundedImage className="shrink-0" userProfile={userProfile} />
        ) : (
          <AnonymousRoundedImage className="shrink-0" />
        ))}
      <div className="min-w-0">
        {userProfile !== null && (
          <p className="text-xs text-left">
            {userProfile ? userProfile.firstName + ' ' + userProfile.lastName : 'Anonymous'}
          </p>
        )}
        <p className=" comment-body text-left -mt-1">{comment.body}</p>
        <p className="text-xs text-left color-light-gray -mt-1">{answers === 1 ? '1 answer' : `${answers} answers`}</p>
      </div>
    </div>
  );
}
